import { observer } from "mobx-react-lite";

import pl from "shared/messages/pl";
import { DynamicAttribute } from "view360Card/models";
import { EntityDetailsItem } from "../entityDetailsItem/EntityDetailsItem";
import { constants } from "shared/constants";
import { formatDate, formatDateTime, formatNumber } from "utils/formattingUtils";
import React from "react";
import { RegularText } from "shared/components";

export interface DynamiAttributesSectionProps {
    attributes: DynamicAttribute[];
    attributeCodesToIgnore?: string[] | undefined;
}

export const getDynamicParameterAttrValue = (attribute: DynamicAttribute) => {
    switch (attribute.definition?.flexField1) {
        case constants.dynamicAttributeTypes.stringAttrType:
            return attribute.stringValue ?? constants.noValue;
        case constants.dynamicAttributeTypes.longAttrType:
            return attribute.longValue ? formatNumber(attribute.longValue) : constants.noValue;
        case constants.dynamicAttributeTypes.decimalAttrType:
            return attribute.decimalValue ? formatNumber(attribute.decimalValue) : constants.noValue;
        case constants.dynamicAttributeTypes.dateAttrType:
            return attribute.dateValue ? formatDate(new Date(attribute.dateValue)) : constants.noValue;
        case constants.dynamicAttributeTypes.dateTimeAttrType:
            return attribute.dateTimeValue ? formatDateTime(new Date(attribute.dateTimeValue)) : constants.noValue;
        case constants.dynamicAttributeTypes.boolAttrType:
            return attribute.booleanValue
                ? pl.common.yes
                : attribute.booleanValue === false
                ? pl.common.no
                : constants.noValue;
        default:
            return "Parametr dynamiczy - nierozpoznany";
    }
};

export const DynamiAttributesSection: React.FC<DynamiAttributesSectionProps> = observer((props) => {
    return (
        <>
            {props.attributes.filter(a => !(props.attributeCodesToIgnore ?? []).includes(a.code ?? "")).map((attribute) => {
                return (
                    <EntityDetailsItem
                        key={attribute.id}
                        label={attribute.definition?.description ?? attribute.definition?.code ?? constants.noValue}
                        content={<RegularText content={getDynamicParameterAttrValue(attribute)}/>}
                    ></EntityDetailsItem>
                );
            })}
        </>
    );
});
